export const bingKey =
  'AvMMCjv1m2WG02X0xGvdFAG0YUpIkf-t_f2WAU0X_WMDUm-ZrV9ZoQPxgM5FvFx0';

//PRUEBA
// export const basePath = 'https://portales.planbsys.com/gpmetwebportalQA/api';
export const basePath = 'https://portales.planbsys.com/gpmetwebportal/api';
